import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn } from "@opensea/ui-kit";
import { expandedSearchTransitionClassNames } from "./constants";
export function ExpandedSearchPage(t0) {
  const $ = _c(14);
  let children;
  let className;
  let direction;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      direction,
      presented: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = direction;
    $[4] = rest;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    direction = $[3];
    rest = $[4];
    t1 = $[5];
  }
  const presented = t1 === undefined ? false : t1;
  let t2;
  if ($[6] !== className || $[7] !== direction || $[8] !== presented) {
    t2 = classNames("scrollbar-hidden absolute inset-0 gap-3 overflow-x-hidden overflow-y-scroll", expandedSearchTransitionClassNames, presented ? "pointer-events-auto translate-x-0 scale-100 opacity-100 blur-0" : classNames("pointer-events-none scale-95 opacity-0 blur-sm", direction === "left" && "-translate-x-5", direction === "right" && "translate-x-5", direction === "center" && "translate-x-0"), className);
    $[6] = className;
    $[7] = direction;
    $[8] = presented;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== rest || $[12] !== t2) {
    t3 = <FlexColumn className={t2} {...rest}>{children}</FlexColumn>;
    $[10] = children;
    $[11] = rest;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}